import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Label = styled.span`
  padding: 1rem 1rem 1rem 0;
  font-size: 1.75rem;
  font-family: ${({ theme }) => theme.standoutFontFamily};
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  border-left: 1px solid #A3193A;
  span {
    font-family: ${({ theme }) => theme.standoutFontFamily};
  }
  span:first-child {
    font-weight: 600;
    font-size: 2rem;
  }
  span:last-child {
    font-weight: 300;
    font-size: .75rem;

  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  color: white;
  margin-bottom: 1rem;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    margin-bottom: 0;
  }
`;

const Clock = ({ deadline }) => {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);

  const leading0 = (num) => ((num < 10) ? `0${num}` : num);

  const getTimeUntil = (dl) => {
    const time = Date.parse(dl) - Date.parse(new Date());

    if (time < 0) {
      setDays(0);
      setHours(0);
      setMinutes(0);
    } else {
      setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
      setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
      setMinutes(Math.floor((time / 1000 / 60) % 60));
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => getTimeUntil(deadline), 1000);

    return () => clearInterval(intervalId);
  }, [deadline]);

  return (
    <Wrapper>
      <Label>Nog:</Label>
      <Item>
        <span>{leading0(days)}</span>
        <span>DAGEN</span>
      </Item>
      <Item>
        <span>{leading0(hours)}</span>
        <span>UREN</span>
      </Item>
      <Item>
        <span>{leading0(minutes)}</span>
        <span>MINUTEN</span>
      </Item>
    </Wrapper>
  );
};

export default Clock;
